import { FiPhone, FiGlobe, FiMapPin, FiStar, FiNavigation } from 'react-icons/fi';

function HotelCard({ hotel, onOpenGallery }) {

  const fallback = "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=1000&q=80";
  const image = hotel.imageUrl && typeof hotel.imageUrl === 'string' && hotel.imageUrl.indexOf('http') === 0
    ? hotel.imageUrl
    : fallback;

  const rating = hotel.rating ?? null;
  const distance = hotel.distance ?? null;
  const phone = hotel.phone ?? null;

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition duration-300 overflow-hidden group relative h-full flex flex-col">

      {/* Rating Badge - Top Left */}
      {rating !== null && (
        <div className="absolute left-3 top-3 bg-yellow-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg z-10 flex items-center gap-1">
          <FiStar size={14} className="fill-white" />
          {rating}
        </div>
      )}

      {/* Distance Badge - Top Right */}
      {distance !== null && (
        <div className="absolute right-3 top-3 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg z-10">
          {distance} km
        </div>
      )}

      {/* Image Wrapper */}
      <div className="overflow-hidden h-48 bg-gray-200">
        <img
          src={image}
          alt={hotel.name}
          onError={(e) => { e.target.onerror = null; e.target.src = fallback; }}
          onClick={() => onOpenGallery && onOpenGallery(hotel)}
          className="w-full h-full object-cover transform transition duration-700 ease-in-out group-hover:scale-110 cursor-pointer"
        />
      </div>

      {/* Content */}
      <div className="p-4 flex flex-col flex-grow">

        {/* Title */}
        <h3 className="text-lg font-semibold text-gray-800 leading-snug mb-3 line-clamp-2">
          {hotel.name}
        </h3>

        {/* Address */}
        <div className="flex items-start gap-2 mb-4 text-sm text-gray-600">
          <FiMapPin size={16} className="text-red-500 flex-shrink-0 mt-0.5" />
          <span className="line-clamp-2">
            {hotel.street && hotel.city ? `${hotel.street}, ${hotel.city}` : hotel.street || hotel.city || 'Address not available'}
          </span>
        </div>

        {/* Action Buttons - Icons Only */}
        <div className="flex items-center justify-center gap-3 mt-auto pt-3">
          {phone ? (
            <a
              href={`tel:${phone}`}
              className="flex items-center justify-center p-3 bg-[#0054a5] hover:bg-opacity-90 text-white rounded-lg transition"
              title="Call"
            >
              <FiPhone size={18} />
            </a>
          ) : (
            <div className="flex items-center justify-center p-3 bg-gray-200 text-gray-400 rounded-lg cursor-not-allowed">
              <FiPhone size={18} />
            </div>
          )}

          {hotel.website ? (
            <a
              href={hotel.website}
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center p-3 bg-[#00a652] hover:bg-opacity-90 text-white rounded-lg transition"
              title="Visit Website"
            >
              <FiGlobe size={18} />
            </a>
          ) : (
            <div className="flex items-center justify-center p-3 bg-gray-200 text-gray-400 rounded-lg cursor-not-allowed">
              <FiGlobe size={18} />
            </div>
          )}

          <button
            onClick={() => {
              const userLat = hotel.userLat || 0;
              const userLng = hotel.userLng || 0;
              const destination = `${hotel.latitude},${hotel.longitude}`;
              const mapsUrl = `https://www.google.com/maps/dir/${userLat},${userLng}/${destination}`;
              window.open(mapsUrl, '_blank');
            }}
            className="flex items-center justify-center p-3 bg-[#7c0046] hover:bg-opacity-90 text-white rounded-lg transition"
            title="Get Directions"
          >
            <FiNavigation size={18} />
          </button>
        </div>

      </div>

    </div>
  );
}

export default HotelCard;
